import { forwardRef, useCallback } from 'react';
import type { CustomContentProps } from 'notistack';
import { SnackbarContent, useSnackbar } from 'notistack';
import { Typography } from '@mui/material';

import IconButton from 'src/components/IconButton';
import { ETHERSCAN_URL, MINTSCAN_URL } from 'src/constants/explorer';

import { CloseImage, Container, ContentWrapper, ErrorComment, Header, RightArrow, Title, ViewWrapper } from './styled';

import { ReactComponent as CloseIcon } from 'src/assets/svg/Close.svg';
import { ReactComponent as RightArrowIcon } from 'src/assets/svg/RightChevron.svg';

interface SnackbarProps extends CustomContentProps {
  txHash?: string;
  errorMsg?: string;
  isCosmosTx?: boolean;
}

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(({ id, ...props }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  return (
    <SnackbarContent ref={ref}>
      <Container>
        <ContentWrapper>
          <Header>
            <Title>
              <Typography variant="h4">{props.message}</Typography>
            </Title>
            <IconButton onClick={handleDismiss}>
              <CloseImage>
                <CloseIcon />
              </CloseImage>
            </IconButton>
          </Header>
          {props.txHash && (
            <ViewWrapper href={`${props.isCosmosTx ? MINTSCAN_URL : ETHERSCAN_URL}/tx/${props.txHash}`} target="_blank">
              <Typography variant="h9">View in explorer</Typography>
              <RightArrow>
                <RightArrowIcon />
              </RightArrow>
            </ViewWrapper>
          )}
          {props.errorMsg && <ErrorComment>{props.errorMsg}</ErrorComment>}
        </ContentWrapper>
      </Container>
    </SnackbarContent>
  );
});

Snackbar.displayName = 'Snackbar';

export default Snackbar;
